import React, { Component } from 'react';
import {
  List,
  WindowScroller,
  AutoSizer,
  CellMeasurer,
  CellMeasurerCache,
} from 'react-virtualized';

class Table extends Component {
  state = {
    rows: [],
  };
  componentDidMount() {
    const rows = this.props.data;
    this.setState({ rows });
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.data != prevProps.data) {
      const rows = this.props.data;
      this.setState({ rows });
    }
  }
  render() {
    const { rows } = this.state;

    const cache = new CellMeasurerCache({
      defaultHeight: 60,
      fixedWidth: true,
    });

    function rowRenderer({
      key, // Unique key within array of rows
      index, // Index of row within collection
      isScrolling, // The List is currently being scrolled
      isVisible, // This row is visible within the List (eg it is not an overscanned row)
      style, // Style object to be applied to row (to position it)
      parent,
    }) {
      const row = rows[index];
      const caso = () => {
        let result = '';
        if (row.caso_nom === 'Sim') result = result + 'Nominativo; ';
        if (row.caso_gen === 'Sim') result = result + 'Genitivo; ';
        if (row.caso_dat === 'Sim') result = result + 'Dativo; ';
        if (row.caso_ac === 'Sim') result = result + 'Acusativo; ';
        if (row.caso_abl === 'Sim') result = result + 'Ablativo; ';
        if (row.caso_voc === 'Sim') result = result + 'Vocativo; ';
        result = result.substring(0, result.length - 2);
        return result;
      };
      const declinacao = () => {
        let result = '';
        if (row.declinacao_1 === 'Sim') result = result + '1ª; ';
        if (row.declinacao_2 === 'Sim') result = result + '2ª; ';
        if (row.declinacao_3 === 'Sim') result = result + '3ª; ';
        if (row.declinacao_4 === 'Sim') result = result + '4ª; ';
        if (row.declinacao_5 === 'Sim') result = result + '5ª; ';
        result = result.substring(0, result.length - 2);
        return result;
      };
      const numero = () => {
        let result = '';
        if (row.plural === 'Sim') result = result + 'Plural; ';
        if (row.singular === 'Sim') result = result + 'Singular; ';
        result = result.substring(0, result.length - 2);
        return result;
      };
      const genero = () => {
        let result = '';
        if (row.masculino === 'Sim') result = result + 'Masculino; ';
        if (row.feminino === 'Sim') result = result + 'Feminino; ';
        if (row.neutro === 'Sim') result = result + 'Neutro; ';
        result = result.substring(0, result.length - 2);
        return result;
      };
      const classificacao = () => {
        let result = '';
        if (row.classificacao1 !== 'NA')
          result = result + row.classificacao1 + '; ';
        if (row.classificacao2 !== 'NA')
          result = result + row.classificacao2 + '; ';
        result = result.substring(0, result.length - 2);
        return result;
      };
      return (
        <CellMeasurer
          cache={cache}
          columnIndex={0}
          key={key}
          overscanRowCount={10}
          parent={parent}
          rowIndex={index}
        >
          <div key={key} style={style}>
            <div className="row-container">
              <div className="container entry-container">
                <div className="row">
                  <div className="col-12">
                    <p className="entry-citacao">
                      <b>Citação</b>
                      <br />
                      <span
                        dangerouslySetInnerHTML={{
                          __html: row.citacao_html,
                        }}
                      ></span>
                    </p>
                    <hr />
                  </div>
                  <div className="col">
                    <p>
                      <b>Divisão MGH</b>
                      <br />
                      {row.divisao_mgh}
                    </p>
                    {row.ano_inicio !== 'NA' ? (
                      <p>
                        <b>Ano</b>
                        <br />
                        {row.ano_inicio}{' '}
                        {row.ano_fim !== 'NA' ? `- ${row.ano_fim}` : null}
                      </p>
                    ) : null}
                    <p>
                      <b>Sujeito Associado</b>
                      <br />
                      {row.sujeito_associado}
                    </p>
                    {row.sujeito_associado_2 !== 'NA' ? (
                      <p>
                        <b>Sujeito Associado 2</b>
                        <br />
                        {row.sujeito_associado_2}
                      </p>
                    ) : null}
                    {row.regiao_associada !== 'NA' ? (
                      <p>
                        <b>Região Associada</b>
                        <br />
                        {row.regiao_associada}
                      </p>
                    ) : null}
                  </div>
                  <div className="col">
                    <p>
                      <b>Conjunto Documental</b>
                      <br />
                      {row.conjunto_documental}
                    </p>
                    <p>
                      <b>Subconjunto Documental</b>
                      <br />
                      {row.subconjunto_documental}
                    </p>
                    <p>
                      <b>Tipo Documental</b>
                      <br />
                      {row.tipo_documental_1}
                      {row.tipo_documental_2 !== 'NA'
                        ? `; ${row.tipo_documental_2}`
                        : null}
                      {row.tipo_documental_3 !== 'NA'
                        ? `; ${row.tipo_documental_3}`
                        : null}
                    </p>
                  </div>
                  <div className="col">
                    <p>
                      <b>Livro</b>
                      <br />
                      {row.livro}
                    </p>
                    {row.no_documento !== 'NA' ? (
                      <p>
                        <b>N˚ Documento</b>
                        <br />
                        {row.no_documento}
                      </p>
                    ) : null}
                    {row.pagina !== 'NA' ? (
                      <p>
                        <b>Página</b>
                        <br />
                        {row.pagina}
                      </p>
                    ) : null}
                  </div>
                  <div className="col">
                    <p>
                      <b>Termo Original</b>
                      <br />
                      {row.termo_original}
                    </p>
                    <p>
                      <b>Palavra Anterior</b>
                      <br />
                      {row.palavra_anterior}
                    </p>
                    <p>
                      <b>Palavra Posterior</b>
                      <br />
                      {row.palavra_posterior}
                    </p>
                  </div>
                  {classificacao() !== '' &&
                  genero() !== '' &&
                  numero() !== '' &&
                  declinacao() !== '' ? (
                    <div className="col">
                      {classificacao() !== '' ? (
                        <p>
                          <b>Classificação</b>
                          <br />
                          {classificacao()}
                        </p>
                      ) : null}
                      {genero() !== '' ? (
                        <p>
                          <b>Gênero</b>
                          <br />
                          {genero()}
                        </p>
                      ) : null}
                      {numero() !== '' ? (
                        <p>
                          <b>Número</b>
                          <br />
                          {numero()}
                        </p>
                      ) : null}
                      {declinacao() !== '' ? (
                        <p>
                          <b>Declinação</b>
                          <br />
                          {declinacao()}
                        </p>
                      ) : null}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </CellMeasurer>
      );
    }
    return (
      <WindowScroller>
        {({ height, width, isScrolling, onChildScroll, scrollTop }) => (
          <AutoSizer>
            {({ height, width }) => (
              <List
                autoHeight
                height={height}
                isScrolling={isScrolling}
                onScroll={onChildScroll}
                rowCount={rows.length}
                rowHeight={cache.rowHeight}
                rowRenderer={rowRenderer}
                scrollTop={scrollTop}
                width={width}
                deferredMeasurementCache={cache}
              />
            )}
          </AutoSizer>
        )}
      </WindowScroller>
    );
  }
}

export default Table;
